import React, {
  useEffect,
} from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import styles from './CourseEpisode.module.css'
import LockIcon from '../../../icons/LockIcon'
import CompleteIcon from '../../../icons/CompleteIcon'

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}))(LinearProgress)

const coursePersent = 100

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    width: ' 40%',
    height: '175px',
    margin: ' 0 10px',
    borderRadius: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'column',
    '@media (max-width: 960px)': {
      width: '26% !important',
    },
    '@media (max-width: 660px)': {
      width: '93% !important',
      // position: 'absolute',
      bottom: '0',
    },
  },
  rootBought: {
    flexGrow: 1,
    width: ' 40%',
    height: '140px',
    margin: ' 0 10px',
    borderRadius: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'column',
    '@media (max-width: 960px)': {
      width: '30% !important',
    },
    '@media (max-width: 600px)': {
      width: '93% !important',
      position: 'absolute',
      bottom: '0',
    },
  },
  progressRoot: {
    color: 'orange',
    height: '15px',
    borderRadius: '10px',
  },
  progressBar: {
    backgroundColor: coursePersent === 100 ? '#8ec389' : '#f9b233',
  },
  progressBarZero: {
    backgroundColor: '',
  },
  progressBarInProgress: {
    backgroundColor: '#f9b233',
  },
  progressBarComplete: {
    backgroundColor: '#8ec389',
  },
})

const CourseEpisode = ({ course, bought, boughtPercent }) => {
  const classes = useStyles()

  console.log(boughtPercent)

  let coursePercent = null

  if (bought) {
    coursePercent = boughtPercent
  } else {
    coursePercent = course?.progressPercent
  }

  console.log('statuscourse', course?.status)

  useEffect(() => {

  }, [course, boughtPercent])

  let imageStyle = {
  }

  const percentStyle = {
    display: 'flex',
    alignSelf: 'flex-start',
    justifyContent: 'end',
  }

  const customProgress = {
    backgroundColor: '#f3f3f3',
    color: 'red',
  }

  let statusIcon = null

  if (course?.status === 100) {
    statusIcon = <LockIcon style={{ width: '55px', height: '75px', filter: 'blur(0)' }} />
    imageStyle = {
      verticalAlign: 'top',
      filter: 'brightness(60%)',
    }
    percentStyle.color = ''
  } else if (course?.status === 103) {
    statusIcon = <CompleteIcon style={{ width: '70px', height: '90px', filter: 'blur(0)' }} />
    imageStyle = {
      verticalAlign: 'top',
      filter: 'brightness(60%)',
    }
    percentStyle.color = '#8ec389'
    customProgress.backgroundColor = '#8ec389'
  } else if (course?.status === 101) {
    statusIcon = null
    imageStyle = null
    percentStyle.color = '#f9b233'
    customProgress.backgroundColor = '#f9b233'
  }

  let progressStyle = null

  if (course?.status === 101) {
    progressStyle = classes.progressBarZero
  } else if (course?.status === 102) {
    progressStyle = classes.progressBarInProgress
  } else if (course?.status === 103) {
    progressStyle = classes.progressBarComplete
  }

  let courseTime = null
  let courseTimeText = null

  if (course?.videoLength / 60 < 1) {
    courseTime = course?.videoLength.toFixed()
    courseTimeText = 'ثانیه'
  } else if (course?.videoLength / 60 > 1) {
    courseTime = (course?.videoLength / 60).toFixed()
    courseTimeText = 'دقیقه'
  } else if (course?.videoLength / 60 > 60) {
    courseTime = ((course?.videoLength / 60) / 60).toFixed()
    courseTimeText = 'ساعت'
  }

  return (
    <div
      className={styles.publicCourseCardBought}
    >
      <div className={styles.listNumer}>
        <span
          className={styles.listNumer_number}
        >
          {course?.order}
        </span>
      </div>
      <div
        className={styles.publicCardImageBought}
      >

        <img
          alt="Remy Sharp"
          src={course?.imageUrl ? course?.imageUrl : `${window.location.origin}/images/row-students-doing-exam_1098-174.jpg`}
          width="100%"
          height="100%"
          style={imageStyle}
          className={styles.publicCourseImage}
        />
        <span
          style={{
            position: 'absolute',
            zIndex: 1000,
            margin: '0 auto',
          }}
        >
          {statusIcon}

        </span>
      </div>
      <div
        className={classes.root}
        style={{ height: bought && '140px' }}
      >
        <div className={styles.section}>{course?.title}</div>
        <div className={styles.publicDescription}>{course?.description}</div>
        <div className={styles.progress}>
          <span style={percentStyle}>
            {coursePercent}
            %
          </span>
          <BorderLinearProgress
            variant="determinate"
            value={coursePercent}
            classes={{
              root: classes.progressRoot,
              bar: progressStyle,
            }}
          />
        </div>
      </div>
      {!bought && (
      <div className={styles.publicCardNumbersBought}>
        <div
          className={styles.publicCardNumberWrap}
        >
          <span className={styles.publicCardNumber}>{course?.videoCount}</span>
          <span className={styles.publicCardNumberText}>تعداد ویدیو</span>
        </div>
        <div
          className={styles.publicCardNumberWrap}
        >
          <span className={styles.publicCardNumber}>{courseTime}</span>
          <span className={styles.publicCardNumberText}>
            {courseTimeText}
          </span>
        </div>
      </div>
      )}
    </div>
  )
}

export default CourseEpisode
